<script setup lang="ts">
const { vote } = useStrapiClient()
const voteConfirmation = voteConfirmationData()
const closeModal = (value?: boolean) => {
  if (value) return

  voteConfirmation.value = undefined
}
const handleVote = () => {
  Promise.resolve(
    vote(
      voteConfirmation.value?.participant?.data?.attributes?.company,
      voteConfirmation.value?.nomination?.data?.attributes?.slug,
    ),
  )

  closeModal()
}
</script>

<template>
  <div>
    <UiModal
      v-if="voteConfirmation"
      :is-visible="!!voteConfirmation"
      :on-close="closeModal"
    >
      <div class="confirmation">
        <h3 class="confirmation__heading">Подтверждение голоса</h3>
        <p>
          Вы отдаёте свой голос участнику
          <b>
            {{ voteConfirmation?.participant?.data?.attributes?.company }}
          </b>
          в номинации «{{
            voteConfirmation?.nomination?.data?.attributes?.shortTitle
          }}». Вы не сможете сегодня больше проголосовать в данной номинации.
        </p>
        <div class="confirmation__actions">
          <button class="button button--accent" @click="handleVote()">
            Отдать голос
          </button>
          <button class="button" @click="closeModal()">Отменить</button>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<style lang="scss" scoped>
.confirmation {
  text-align: center;
  padding: 3rem;

  &__heading {
    margin-bottom: 1.45em;
  }
  &__actions {
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin-top: 2.45rem;

    .button {
      padding: 16px;
      width: 100%;
      color: #000;
      border: 1px solid #000;
      border-radius: 100px;
      transition: ease-in-out 0.335s;

      &--accent {
        color: #fff;
        border-color: transparent;
        background-color: #6a45ff;
      }
      &:hover {
        color: #fff;
        background-color: #5738cf;
        border-color: transparent;
      }
    }
  }

  @include sm {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
}
</style>
